
export const TYPE_TEXT = 'text';
export const TYPE_BOOLEAN = 'bool';
export const TYPE_NUMBER = 'number';
export const TYPE_SINGLE = 'single';
export const TYPE_MULTI = 'multi';
export const TYPE_HEADER = 'header';
export const TYPE_CONFIRM = 'confirm';
export const TYPE_ADDRESS = 'address';

export default class FormField {

  constructor(data) {
    this._data = {
      id: `${Math.round(Math.random() * 1000000000)}`,
      label: '',
      description: '',
      required: false,
      filter: false,
      type: TYPE_TEXT,
      options: [],
      defaultValue: null
    };
    if (data) {
      this._data = { ...this._data, ...data };
    }
  }

  get id() {
    return this._data.id;
  }

  get isHeader() {
    return this.type === TYPE_HEADER;
  }

  get isText() {
    return this.type === TYPE_TEXT;
  }

  get isBoolean() {
    return this.type === TYPE_BOOLEAN;
  }

  get isConfirmation() {
    return this.type === TYPE_CONFIRM;
  }

  get isAddress() {
    return this.type === TYPE_ADDRESS;
  }

  get isNumber() {
    return this.type === TYPE_NUMBER;
  }

  get isSingle() {
    return this.type === TYPE_SINGLE;
  }

  get isMulti() {
    return this.type === TYPE_MULTI;
  }

  get type() {
    return this._data.type;
  }
  set type(type) {
    this._data.type = type;
  }

  get label() {
    return this._data.label;
  }
  set label(label) {
    this._data.label = label;
  }

  get description() {
    return this._data.description;
  }
  set description(description) {
    this._data.description = description;
  }

  get options() {
    return this._data.options;
  }
  set options(options) {
    this._data.options = options;
  }

  get required() {
    return this._data.required;
  }
  set required(required) {
    this._data.required = required;
  }

  get filterEnabled() {
    return this._data.filter;
  }
  set filterEnabled(filterEnabled) {
    this._data.filter = filterEnabled;
  }

  get defaultValue() {
    return this._data.defaultValue;
  }
  set defaultValue(defaultValue) {
    this._data.defaultValue = defaultValue;
  }

  get hasDefaultValue() {
    return this.defaultValue !== null;
  }

  get hasOptions() {
    return this.type === TYPE_SINGLE || this.type === TYPE_MULTI;
  }

  addOption() {
    let options = this.options;
    options.push('');
    this.options = options;
  }

  removeOption(option) {
    this.options = this.options.filter(o => o !== option);
  }

  get hasValue() {
    return this.type !== TYPE_HEADER;
  }

  get supportsRequiredFlag() {
    return this.type !== TYPE_HEADER && this.type !== TYPE_CONFIRM;
  }

  get supportsDefault() {
    return this.type !== TYPE_HEADER && this.type !== TYPE_CONFIRM;
  }

  get showIf() {
    return this._data.showIf || {};
  }

  set showIf(showIf) {
    this._data.showIf = showIf;
  }

  addCondition(fieldId) {
    this.setCondition(fieldId, null);
  }

  removeCondition(fieldId) {
    let showIf = this.showIf;
    delete showIf[fieldId];
    this.showIf = showIf;
  }

  setCondition(fieldId, value) {
    let showIf = this.showIf;
    showIf[fieldId] = value;
    this.showIf = showIf;
  }

  get typeSpecificSurveyJson() {
    switch (this.type) {
      case TYPE_TEXT:
        return {
          type: 'text'
        };
      case TYPE_MULTI:
        return {
          type: 'checkbox',
          choices: this.options
        };
      case TYPE_NUMBER:
        return {
          type: 'text',
          inputType: 'number'
        };
      case TYPE_SINGLE:
        return {
          type: 'radiogroup',
          choices: this.options
        };
      case TYPE_HEADER:
        return {
          type: 'expression',
          hideNumber: true
        };
      case TYPE_ADDRESS:
        return {
          type: 'address'
        };
      case TYPE_CONFIRM:
        return {
          type: 'checkbox',
          isRequired: true,
          validators: [
            { "type": "answercount", "minCount": 1 }
          ],
          choices: [
            { "value": "agree", "text": this.description }
          ]
        };
      case TYPE_BOOLEAN:
        return {
          type: 'boolean'
        };
      default:
        return {
          type: 'text'
        };
    }
  }

  get surveyJson() {
    return {
      name: this.id,
      title: this.label,
      description: this.isConfirmation ? null : this.description,
      defaultValue: this.defaultValue,
      ...this.typeSpecificSurveyJson
    };
  }

  serialize() {
    return { ...this._data };
  }
}
